import { render, staticRenderFns } from "./yDProductImg.vue?vue&type=template&id=7828bc74&scoped=true&"
import script from "./yDProductImg.vue?vue&type=script&lang=js&"
export * from "./yDProductImg.vue?vue&type=script&lang=js&"
import style0 from "./yDProductImg.vue?vue&type=style&index=0&id=7828bc74&scoped=true&lang=css&"
import style1 from "./yDProductImg.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7828bc74",
  null
  
)

export default component.exports